module.exports = __webpack_public_path__ + "static/media/9DESA24.411bd6dd.jpg";